import Base from './Base';

const ENTITY = 'config';
export const REDUCER_NAME = ENTITY;

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const news = new Base(ENTITY, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);
news.putAsync.bind(news);
news.postAsync.bind(news);

export const get = (section) => {
  return news.getAsync(`${ENTITY}?section=${section}`);
};

export const put = (section, data) => {
  return news.putAsync(`${ENTITY}?section=${section}`, data);
};



// WEBPACK FOOTER //
// ./src/redux/modules/config.js